import { useFetcher } from '@remix-run/react'
import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { ClientOnly } from 'remix-utils/client-only'
import nix18 from '#app/images/NIX18_pms.png'
import { type ActionData } from '#app/newsletter/types.js'
import { H3 } from './typography'
import { Button } from './ui/button'

const AgeGateModal = ({
	isOpen,
	children,
}: {
	isOpen: boolean
	children: any
}) => {
	if (!isOpen) return <p>s</p>

	return (
		<div className="z-1000 fixed left-0 top-0 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
			<div className="z-100 max-h-xl max-w-xl rounded-md bg-white p-10">
				{children}
			</div>
		</div>
	)
}

// Currently closes modal by setting cookie and reloading from root, not ideal...
export default function AgeGate() {
	const ageGateFetcher = useFetcher<ActionData>()
	const formRef = useRef<HTMLFormElement>(null)
	const isDone = ageGateFetcher.state === 'idle' && ageGateFetcher.data != null
	const ageGateData = isDone ? ageGateFetcher.data : null

	const [isOpen, setIsOpen] = useState(true)

	useEffect(() => {
		setIsOpen(true)
	}, [])

	useEffect(() => {
		if (formRef.current && ageGateData?.status === 'success') {
			formRef.current.reset()
			setIsOpen(false)
		}
	}, [ageGateData])

	const closeModal = async (isOfAge: boolean) => {}

	return (
		<ClientOnly>
			{() =>
				createPortal(
					<AgeGateModal isOpen={isOpen}>
						<ageGateFetcher.Form
							ref={formRef}
							method="POST"
							action="/action/age-gate"
						>
							<H3>Ben je 18 jaar of ouder?</H3>
							<div className="flex flex-row items-center justify-between">
								<img src={nix18} alt="Nix 18 logo" className="h-5" />
								<div className="flex flex-row justify-end gap-4">
									<input type="hidden" name="ageGate" value="true" />
									<Button onClick={closeModal}>Ja</Button>
									<Button onClick={closeModal}>Nee</Button>
								</div>
							</div>
						</ageGateFetcher.Form>
					</AgeGateModal>,
					document.getElementById('agegate-portal'),
				)
			}
		</ClientOnly>
	)
}
